import React from 'react';
import { FormDemo, FormNewsletter } from './Form';

const DemoCTA = ({ buttonLabel }) => {
  return <FormDemo formID="cta-demo-form" buttonLabel={buttonLabel} />;
};

export default DemoCTA;
